import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import QuestionAnswerDisplay, {
    getAnswerDisplayPropsFromAnswer,
} from "common/Question/AnswerDisplay";
import { questionAnswerShape, questionProps } from "lib/propTypes";
import { preventDefault } from "lib/util";
import QuestionButtonGroup from "common/Question/QuestionButtonGroup";
import { OutlinedButton } from "common/DS/Buttons";

const SelectOneAutoselect = ({
    answer,
    handleSelect,
    handleSkip,
    selectedAnswer,
    response,
    showFollowUp,
    isLastQuestion,
    isRequired,
    // ignoring arrow body to avoid probable merge conflict with #3135 as suggested
    /* eslint-disable-next-line arrow-body-style */
}) => {
    const selectedResponse = response?.response || response;

    const hasIconDisplay = answer.some((a) => !!a.display_icon);

    return (
        <>
            {!selectedAnswer && (
                <div
                    className={classNames({
                        "link-group": !hasIconDisplay,
                        "check-in__icon-group": hasIconDisplay,
                    })}
                >
                    {answer.map((a) => {
                        const isSelected = a.id === selectedResponse;
                        const props = {
                            size: "large",
                            className: classNames({
                                "questions__answer--selected": isSelected,
                            }),
                            key: a.id,
                            "data-id": a.id,
                            selected: isSelected,
                        };
                        const displayProps = getAnswerDisplayPropsFromAnswer(a);
                        return hasIconDisplay ? (
                            <a href="#" {...props} onClick={preventDefault(handleSelect)}>
                                <QuestionAnswerDisplay {...displayProps} />
                            </a>
                        ) : (
                            <OutlinedButton {...props} onClick={handleSelect}>
                                <QuestionAnswerDisplay {...displayProps} />
                            </OutlinedButton>
                        );
                    })}
                </div>
            )}
            {!showFollowUp && (
                <QuestionButtonGroup
                    handleSkip={handleSkip}
                    isLastQuestion={isLastQuestion}
                    isRequired={isRequired}
                />
            )}
        </>
    );
};

SelectOneAutoselect.propTypes = {
    answer: PropTypes.arrayOf(questionAnswerShape).isRequired,
    response: questionProps.response,
    handleSelect: PropTypes.func.isRequired,
    handleSkip: PropTypes.func.isRequired,
    selectedAnswer: PropTypes.shape({
        answerData: PropTypes.shape({
            responseText: PropTypes.string,
        }),
    }),
    showFollowUp: PropTypes.bool.isRequired,
    isLastQuestion: PropTypes.bool,
    isRequired: PropTypes.bool,
};

SelectOneAutoselect.defaultProps = {
    response: null,
    selectedAnswer: null,
    isLastQuestion: false,
    isRequired: false,
};

export default React.memo(SelectOneAutoselect);
